import React from 'react';
import CategoriesSection from '../sections/Home/CategoriesSection';
import OpeningSection from '../sections/Home/OpeningSection';
import OrderNowSection from '../sections/Home/OrderNowSection';
import Header from '../components/Header/Header';
import HomeBanner from '../banners/Home-Banner/HomeBanner';
import AboutSection from '../sections/Home/AboutUs';

const Home = () => {
  return (
    <div className="home-page">
      <Header />
      <HomeBanner />
      <AboutSection />
      <CategoriesSection />
      <OrderNowSection />
      <OpeningSection />
    </div>
  );
};

export default Home; 